import { useState, useRef, useEffect } from "react";
import { MoreVertical, UserPlus, Pencil, Trash2 } from "lucide-react";

// Reusable "⋯" actions menu. Pass any of onInvite / onEdit / onDelete to show them.
// `testId` should be unique per row (e.g. the record id).
export const ItemMenu = ({ onInvite, onEdit, onDelete, testId = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const act = (fn) => (e) => {
    e.preventDefault(); e.stopPropagation();
    setOpen(false);
    fn && fn();
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid={`item-menu-${testId}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
        className="p-1.5 rounded-md text-navy/40 hover:text-navy hover:bg-navy/5 transition-colors">
        <MoreVertical className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 top-8 z-50 w-44 bg-white border border-navy/10 rounded-lg shadow-lg py-1.5 overflow-hidden">
          {onInvite && (
            <button data-testid={`item-invite-${testId}`} onClick={act(onInvite)}
              className="w-full flex items-center gap-2.5 px-4 py-2 text-sm text-navy/70 hover:bg-navy/5 transition-colors">
              <UserPlus className="w-4 h-4" /> Invitar usuarios
            </button>
          )}
          {onEdit && (
            <button data-testid={`item-edit-${testId}`} onClick={act(onEdit)}
              className="w-full flex items-center gap-2.5 px-4 py-2 text-sm text-navy/70 hover:bg-navy/5 transition-colors">
              <Pencil className="w-4 h-4" /> Editar
            </button>
          )}
          {onDelete && (
            <button data-testid={`item-delete-${testId}`} onClick={act(onDelete)}
              className="w-full flex items-center gap-2.5 px-4 py-2 text-sm text-destructive hover:bg-destructive/5 transition-colors">
              <Trash2 className="w-4 h-4" /> Eliminar
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemMenu;
